import { render, staticRenderFns } from "./WorkWeChatList.vue?vue&type=template&id=86484708&scoped=true&"
import script from "./WorkWeChatList.vue?vue&type=script&lang=js&"
export * from "./WorkWeChatList.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=86484708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86484708",
  null
  
)

export default component.exports